const Lemo_Autocomplete = {
    build: function (selectorParent, selector, url, urlQuery, callback) {
        try {
            var selectorComposed = '';
            if ('body' === selectorParent) {
                selectorComposed = selectorParent + ' ' + selector;
            } else {
                var parentModal = $(selector).parents('.modal').first();
                if (parentModal.length) {
                    selectorComposed = '#' + parentModal.attr('id') + ' ' + selector;
                }
            }

            $(selector).on('blur', selector + 'Autocomplete', function () {
                if (this.value === '') {
                    $(selectorComposed).val('');
                }
            });

            $(selectorComposed + 'Autocomplete').autocomplete({
                autofocus: true,
                delay: 250,
                minLenght: 0,
                source: function (request, response) {
                    try {
                        urlQuery.q = $(selectorComposed + 'Autocomplete').val();
                    } catch (e) {
                        urlQuery = {};
                        urlQuery.q = $(selectorComposed + 'Autocomplete').val();
                    }

                    $.ajax({
                        url: url,
                        dataType: "json",
                        type: "GET",
                        data: urlQuery,
                        success: function (data) {
                            if (0 == data.length) {
                                Lemo_Alert.addDanger('No items do not match the expression', 'autocomplete');
                            }
                            response(data);
                        }
                    })
                },
                select: function (e, ui) {
                    e.preventDefault();

                    if (ui.item == null) {
                        $(selectorComposed).val('');
                        $(this).val('');
                    } else {
                        $(this).val(ui.item.label);

                        $(selectorComposed).val(ui.item.id).blur();
                    }

                    if (callback && typeof (callback) === "function") {
                        callback();
                    }
                },
                'change': function (e, ui) {
                    e.preventDefault();

                    if (ui.item == null) {
                        $(selectorComposed).val('');
                        $(this).val('');

                        if (callback && typeof (callback) === "function") {
                            callback();
                        }
                    }
                },
                'open': function (e) {
                    $(e.target).addClass('open');
                },
                'close': function (e) {
                    $(e.target).removeClass('open');
                }
            });
        } catch (e) {
            console.log(e.message, e.stack);
        }
    }
}

